import { Map } from 'immutable'
import React from 'react'
import { Action, AsyncState, IOWidget, mkWidget, mk_widget, Pair } from 'widgets-for-react'
import { ImageSize } from '../../../../cms/blocks/types.gen'
import { getClassName } from '../../../../cms/blocks/utils.gen'
import { ImageContainer } from '../../../../cms/blocks/widgets/ImageContainer.gen'
import { TemplateState } from '../../../../cms/page/types.gen'
import { video, VideoProps } from '../../../../video'
import { CustomBlock } from '../../../../wordpress/types_and_parser/custom_blocks.gen'
import { Block } from '../../../../wordpress/types_and_parser/standard_blocks.gen'
import { Acf } from '../../../../wordpress/types_and_parser/types.mod'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { TabProps, tabs } from '../../../utils/tabs'
import { CustomBlockData } from '../types.mod'

export type BSLTabsBlockProps<customBlockData, extra_images> = {
  title: string
  intro: string
  items: Array<BSLTabItemProps<extra_images>>
}

export type BSLTabItemProps<extra_images> = {
  key?: string
  tab_title: string
  title?: string
  text: Acf.Wysiwyg
  kind_media: 'video' | 'image'
  video: VideoProps
  image: number
  image_size: ImageSize<extra_images>
  image_alt: string
  get_default_data_src: () => ImageSize<extra_images>
  get_default_data_srcset: () => Array<Pair<ImageSize<extra_images>, string>>
}

export type BSLTabsBlockStyle = Partial<{
  block_classname: string
  header_classname: string
  title_classname: string
  intro_classname: string
  item_classname: string
  item_content_classname: string
  item_title_classname: string
  item_description_classname: string
  item_figure_classname: string
  item_image_classname: string
}>

export function BSLTabsBlock<customBlockData, extra_images>(
  props: BSLTabsBlockProps<customBlockData, extra_images>,
  options?: { style?: BSLTabsBlockStyle; key?: string }
): IOWidget<
  TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>,
  Action<TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>>
> {
  return (s: TemplateState<CustomBlockData, CustomBlock, Block, extra_images, PublicSite_CustomPageData>) =>
    mk_widget({
      run: _ => (
        <section
          className={getClassName(options, 'block_classname', 'block')}
          key={options && options.key ? options.key : ''}
        >
          <header className={getClassName(options, 'header_classname', '')}>
            <h2 className={getClassName(options, 'title_classname', '')}>{props.title}</h2>
            <div className={getClassName(options, 'intro_classname', '')}>{props.intro}</div>
          </header>
          {tabs(
            props.items.map<TabProps>(item => {
              console.log(item.image)
              const imageState = s.images.get(item.image)
              return {
                tab: active =>
                  mkWidget({
                    run: activate => (
                      <button onClick={activate} className={`tab tab--${active ? 'active' : 'inactive'} title--xxs`}>
                        {item.tab_title}
                      </button>
                    )
                  }),
                content: active =>
                  mkWidget({
                    run: () => (
                      <div
                        key={options.key && item && item.key ? `${options.key}-${item.key}` : ''}
                        className={`${getClassName(options, `item_classname`, '')} ${active ? '' : 'hidden'}`}
                      >
                        <figure className={getClassName(options, 'item_figure_classname', ``)}>
                          {item.kind_media === 'image'
                            ? s.images.has(item.image)
                              ? ImageContainer(
                                  s.images.get(item.image) as AsyncState<Map<ImageSize<extra_images>, string>>,
                                  item.image_size,
                                  getClassName(options, 'item_image_classname', 'w-100'),
                                  item.image_alt,
                                  item.get_default_data_src,
                                  item.get_default_data_srcset
                                ).run(_ => {})
                              : null
                            : item.kind_media === 'video' && item.video 
                              ? video('image' in item && s.images.has(item.image) && imageState.kind == 'loaded' ? imageState.value.get(item.image_size || 'full') : '')(item.video).run(() => null) 
                              : null
                            }
                        </figure>
                        <div className={getClassName(options, 'item_content_classname', '')}>
                          {item.title && (
                            <h3 className={getClassName(options, 'item_title_classname', '')}>{item.title}</h3>
                          )}
                          <div
                            className={getClassName(options, 'item_description_classname', '')}
                            dangerouslySetInnerHTML={{ __html: item.text }}
                          />
                        </div>
                      </div>
                    )
                  })
              }
            })
          )}
        </section>
      )
    })
}
